module.exports = __webpack_public_path__ + "static/media/location.5ae0e272.svg";